import Color from 'color'
import { EventStatus } from '../Event'
import fetchObject from './fetchObject'
import fetchSettings from './fetchSettings'
import saveProfile from './saveProfile'
import deleteLogo from './deleteLogo'
import updateLogo from './updateLogo'
import updateSettings from './updateSettings'

export {
  fetchObject,
  fetchSettings,
  saveProfile,
  updateSettings,
  deleteLogo,
  updateLogo,
}

export interface IObject {
  profile?: IProfile
  settings?: ISettings
  summary?: ISummary
}

export interface IIdentification {
  id: number
}

export interface IProfile extends IIdentification {
  id: number
  name: string
  idCurrency: number
  idCountry: number
  street: string
  postCode: string
  city: string
  phone: string
  email: string
  www: string
  facebook: string
  companyName: string
  companyCountry: number
  companyStreet: string
  companyPostCode: string
  companyCity: string
  companyVatNumber: string
  accountNumber: string
  swift: string
  type: number
  logoUrl: string
  pricelistVersion: '1' | '2'
}

export interface ISettings extends IIdentification {
  summary: ISummary
  eventShape: EventShape
  cancelFree: string
  cancelPay: string
  send_mail_client_reservation: string
  send_mail_reservation: string
  serviceCleaning: number
  serviceBedding: number
  serviceTowels: number
  provision: any
  serviceCleaningStatus: CleaningStatus
  serviceBeddingStatus: CleaningStatus
  serviceTowelsStatus: CleaningStatus
  serviceCleaningDays: boolean[]
  serviceBeddingDays: boolean[]
  serviceTowelsDays: boolean[]
  show_busy_terms: boolean
  prepayment_type: PrepaidType
  defaultPrepaidType: PrepaidType
  defaultFeedingType: FeedingType
  defaultReservationStatus: EventStatus
  pricelist_multi: boolean
  pricelist_multi_can_switch: boolean
  dateFormat?: {
    date: string
    hour: string
  }
  daynightFrom?: string
  daynightTo?: string
  eventLabel: string
  customReservationStatus: {
    colors: ICustomReservation<Color>
    names: ICustomReservation<string>
  }
}

export enum CleaningStatus {
  Days,
  CheckOut,
  WeekDays,
}

export interface ICustomReservation<T = string> {
  [EventStatus.NoPayment]: T
  [EventStatus.Advance]: T
  [EventStatus.Full]: T
  [EventStatus.Canceled]: T
  [EventStatus.Unavailable]: T
}

export interface ISummary {
  fulfillment: boolean
  feeding: boolean
  checkinout: boolean
}

export type EventShape = 'square' | 'diamond'

export enum PrepaidType {
  PaidDown = 0,
  Advance = 1,
}

export enum FeedingType {
  WithoutFood = 'OV',
  Breakfast = 'BB',
  WithDinner = 'HB',
  FullFood = 'FB',
}
